import { render } from "./UserForm.vue?vue&type=template&id=55669cd5&ts=true"
import script from "./UserForm.vue?vue&type=script&lang=ts"
export * from "./UserForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/UserForm/UserForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55669cd5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55669cd5', __exports__)) {
    api.reload('55669cd5', __exports__)
  }
  
  module.hot.accept("./UserForm.vue?vue&type=template&id=55669cd5&ts=true", () => {
    api.rerender('55669cd5', render)
  })

}


export default __exports__